import { Filter } from '@nostr/tools/filter'
import { decode } from '@nostr/tools/nip19'
import { queryProfile } from '@nostr/tools/nip05'
import { isHex32 } from '@nostr/gadgets/utils'

export async function parseFilter(input: string, currentPubkey?: string): Promise<Filter | null> {
  const parts = input.trim().split(/\s+/)
  const filter: Filter = {}

  const searchTerms = []

  for (const part of parts) {
    if (!part) continue

    const sep = part.indexOf(':')
    if (sep === -1) {
      searchTerms.push(part)
      continue
    }
    const key = part.slice(0, sep)
    const value = part.slice(sep + 1)
    if (!key || !value) {
      searchTerms.push(part)
      continue
    }

    switch (key) {
      case 'kind':
      case 'k': {
        filter.kinds = filter.kinds || []
        const n = parseInt(value, 10)
        if (isNaN(n)) return null
        filter.kinds.push(n)
        break
      }
      case 'author':
      case 'a':
        filter.authors = filter.authors || []
        if (value === 'me') {
          if (currentPubkey) filter.authors.push(currentPubkey)
          else return null
          break
        }
        try {
          const { type, data } = decode(value)
          if (type === 'npub') {
            filter.authors.push(data)
          } else if (type === 'nprofile') {
            filter.authors.push(data.pubkey)
          } else return null
        } catch {
          /***/
        }
        if (isHex32(value)) filter.authors.push(value)
        else {
          const pp = await queryProfile(value)
          if (pp) {
            filter.authors.push(pp.pubkey)
          } else return null
        }
        break
      case 'id':
        try {
          const { type, data } = decode(value)
          if (type === 'note') {
            filter.ids = filter.ids || []
            filter.ids.push(data)
          } else if (type === 'nevent') {
            filter.ids = filter.ids || []
            filter.ids.push(data.id)
          } else if (type === 'naddr') {
            filter.kinds = [data.kind]
            filter.authors = [data.pubkey]
            filter['#d'] = [data.identifier]
          } else return null
        } catch {
          if (!isHex32(value)) return null
          filter.ids = filter.ids || []
          filter.ids.push(value)
        }
        break
      case 'limit': {
        const n = parseInt(value, 10)
        if (isNaN(n) || n < 1) return null
        filter.limit = n
        break
      }
      case 'since': {
        const n = parseInt(value, 10)
        if (isNaN(n)) return null
        filter.since = n
        break
      }
      case 'until': {
        const n = parseInt(value, 10)
        if (isNaN(n)) return null
        filter.until = n
        break
      }
      default:
        if (key.startsWith('#')) {
          let v = value
          try {
            const { type, data } = decode(value)
            if (type === 'nevent') v = data.id
            else if (type === 'npub') v = data
            else if (type === 'nprofile') v = data.pubkey
            else if (type === 'naddr') v = `${data.kind}:${data.pubkey}:${data.identifier}`
          } catch {
            /***/
          }

          filter[key as `#${string}`] = filter[key as `#${string}`] || []
          filter[key as `#${string}`]!.push(v)
        }
        break
    }
  }

  if (searchTerms.length > 0) filter.search = searchTerms.join(' ')
  if (Object.keys(filter).length === 0) return null

  return filter
}
